import React from 'react';
import VectorIcon from './VectorIcon';
import IconProps from './IconProps';
import colors from '../../theme/colors';

const FilledDeleteIcon = ({
  width = 22,
  height = 22,
  colorBack = colors.madison,
  colorIcon = colors.white,
}: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <g>
      <rect width="12" height="12" fill={colorIcon} x="6" y="6" />
      <path
        d="M19.9374 2.75H7.52677C6.90572 2.75 6.32365 3.02526 
          5.92951 3.50663L0.154962 10.565C-0.0518168 10.8181 -0.0518168 11.182 
          0.154962 11.4351L5.93023 18.494C6.32365 18.9747 6.90577 19.25 7.52677 
          19.25H19.9374C21.0747 19.25 21.9999 18.3248 21.9999 17.1875V4.81255C21.9999 
          3.67519 21.0747 2.75 19.9374 2.75ZM16.7846 13.4654L14.8402 15.4097L12.3749 
          12.9444L9.90959 15.4097L7.96525 13.4654L10.4306 11L7.96525 8.53473L9.90959 
          6.59039L12.3749 9.0557L14.8402 6.59039L16.7846 8.53473L14.3192 11C14.3192 
          11 16.7846 13.4654 16.7846 13.4654Z"
        fill={colorBack}
      />
    </g>
  </VectorIcon>
);

export default FilledDeleteIcon;
